/**
 * App API
 */
import AppComponents from './app-components.json'
import AppTemplates from './app-templates.json'
import AppColors from './app-colors.json'
import AppSettings from './app-settings.json'

export default {
  /**
   * App componentsを、IDをキーとしたオブジェクトとして返す
   */
  components: AppComponents.reduce((p, c) => { p[c.id] = c; return p }, {}),

  /**
   * App componentsを配列として返す
   */
  componentsArray: AppComponents,

  /**
   * 引数に指定されているtypeをもつcomponentを配列として返す
   *
   * @param string type
   */
  componentsArrayOfType (type) {
    return AppComponents.filter(component => component.meta.type === type)
  },

  /**
   * App templatesを、IDをキーとしたオブジェクトとして返す
   */
  templates: AppTemplates.map(template => ({[template.id]: template})),

  /**
   * App templatesを配列として返す
   */
  templatesArray: AppTemplates,

  /**
   * App colorsをオブジェクトとして返す
   */
  colors: AppColors,

  /**
   * App settingsをオブジェクトとして返す
   */
  settings: AppSettings,

  /**
   * App settingsのプロパティを配列として返す
   */
  settingsProps: Object.keys(AppSettings),

  /**
   * App settingsから設定情報だけを抜き出してオブジェクトとして返す
   */
  settingsDefault: getSettingsFromTemplate(AppSettings)
}

function getSettingsFromTemplate (template) {
  return Object.keys(template).reduce((prev, curr) => {
    prev[curr] = recursiveReduce(template[curr])
    return prev
  }, {})
}

function recursiveReduce (template) {
  return Object.keys(template).reduce((prev, curr) => {
    if (curr === 'meta') return prev
    switch (template[curr].type) {
      case 'text':
        prev[curr] = template[curr].default || ''
        break
      case 'number':
        prev[curr] = template[curr].default || 0
        break
      case 'checkbox':
        prev[curr] = template[curr].values.map(elm => elm.default)
        break
      default:
        prev[curr] = recursiveReduce(template[curr])
        break
    }
    return prev
  }, {})
}



// WEBPACK FOOTER //
// ./src/api/index.js